import * as React from 'react';
import { useField } from 'formik';
import { BaseOTPAuthenticationWidgetProps, OTPAuthenticationWidget } from './OTPAuthenticationWidget';
import { InputWrapperWidget } from '../inputs';
import { styled } from '../../theme';

export interface FormikOTPAuthenticationWidgetProps extends BaseOTPAuthenticationWidgetProps {
  name: string;
  label?: string;
}

namespace S {
  export const InputWrapper = styled(InputWrapperWidget)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;
}

export const FormikOTPAuthenticationWidget: React.FC<FormikOTPAuthenticationWidgetProps> = (props) => {
  const [field, meta, helpers] = useField<string>(props.name);

  return (
    <S.InputWrapper className={props.className} label={props.label}>
      <OTPAuthenticationWidget
        onChange={(code) => {
          helpers.setValue(code);
        }}
        otpValues={field.value.split('')}
        error={meta.error}
        {...props}
      />
    </S.InputWrapper>
  );
};
